module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "main products home"
  }, [_c('div', {
    staticClass: "bannerBackground"
  }, [_c('div', {
    staticClass: "banner"
  }, [_c('p', {
    staticStyle: {
      "color": "#fff",
      "font-weight": "bold"
    }
  }, [_vm._v(_vm._s(_vm.$t('title1')))]), _vm._v(" "), _c('p', {
    staticStyle: {
      "color": "#5ea2ec",
      "font-weight": "bold"
    }
  }, [_vm._v(_vm._s(_vm.$t('title2')))]), _vm._v(" "), _c('p', {
    staticStyle: {
      "color": "rgba(238, 238, 238, 0.8)",
      "font-size": "24px"
    }
  }, [_vm._v(_vm._s(_vm.$t('subtitle')))])]), _vm._v(" "), _c('div', {
    staticClass: "get-start"
  }, [_c('el-input', {
    attrs: {
      "placeholder": _vm.$t('placeholder')
    },
    nativeOn: {
      "keyup": function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13, $event.key)) { return null; }
        $event.stopPropagation();
        _vm.getStart($event)
      }
    },
    model: {
      value: (_vm.startInput),
      callback: function($$v) {
        _vm.startInput = $$v
      },
      expression: "startInput"
    }
  }), _vm._v(" "), _c('el-button', {
    on: {
      "click": _vm.getStart
    }
  }, [_vm._v(_vm._s(_vm.$t('getstart')))])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "mainContent"
  }, [_c('div', {
    staticClass: "home-part crait-advantage"
  }, [_c('div', {
    staticClass: "home-info"
  }, [_c('p', {
    staticClass: "home-title title"
  }, [_vm._v(_vm._s(_vm.$t('contitle')))])]), _vm._v(" "), _c('div', {
    staticClass: "home-intro"
  }, [_vm._m(0), _vm._v(" "), _c('ul', {
    staticClass: "home-crait-advantage-intro"
  }, [_c('li', [_c('p', {
    staticClass: "home-intro-title title"
  }, [_vm._v(_vm._s(_vm.$t('intro1-title')))]), _vm._v(" "), _c('p', {
    staticClass: "home-intro-detail"
  }, [_vm._v(_vm._s(_vm.$t('intro1-detail')))])])])]), _vm._v(" "), _c('div', {
    staticClass: "home-intro"
  }, [_c('ul', {
    staticClass: "home-crait-advantage-intro secureCommunication"
  }, [_c('li', [_c('p', {
    staticClass: "home-intro-title title"
  }, [_vm._v(_vm._s(_vm.$t('intro2-title')))]), _vm._v(" "), _c('p', {
    staticClass: "home-intro-detail"
  }, [_vm._v(_vm._s(_vm.$t('intro2-detail')))])])]), _vm._v(" "), _vm._m(1)]), _vm._v(" "), _c('div', {
    staticClass: "home-intro"
  }, [_vm._m(2), _vm._v(" "), _c('ul', {
    staticClass: "home-crait-advantage-intro organization"
  }, [_c('li', [_c('p', {
    staticClass: "home-intro-title title"
  }, [_vm._v(_vm._s(_vm.$t('intro3-title')))]), _vm._v(" "), _c('p', {
    staticClass: "home-intro-detail"
  }, [_vm._v(_vm._s(_vm.$t('intro3-detail')))])])])])]), _vm._v(" "), _c('div', {
    staticClass: "home-part key-features"
  }, [_c('div', {
    staticClass: "home-info"
  }, [_c('p', {
    staticClass: "home-title title"
  }, [_vm._v(_vm._s(_vm.$t('keyfeature-title')))])]), _vm._v(" "), _c('div', {
    staticClass: "home-intro key-feature-intro"
  }, [_c('ul', {
    staticClass: "key-feature-lists"
  }, [_c('li', [_vm._m(3), _vm._v(" "), _c('div', {
    staticClass: "features-detail title"
  }, [_vm._v(_vm._s(_vm.$t('keyfeature-list1')))])]), _vm._v(" "), _c('li', [_vm._m(4), _vm._v(" "), _c('div', {
    staticClass: "features-detail title"
  }, [_vm._v(_vm._s(_vm.$t('keyfeature-list2')))])]), _vm._v(" "), _c('li', [_vm._m(5), _vm._v(" "), _c('div', {
    staticClass: "features-detail title"
  }, [_vm._v(_vm._s(_vm.$t('keyfeature-list3')))])])]), _vm._v(" "), _c('ul', {
    staticClass: "key-feature-lists"
  }, [_c('li', [_vm._m(6), _vm._v(" "), _c('div', {
    staticClass: "features-detail title"
  }, [_vm._v(_vm._s(_vm.$t('keyfeature-list4')))])]), _vm._v(" "), _c('li', [_vm._m(7), _vm._v(" "), _c('div', {
    staticClass: "features-detail title"
  }, [_vm._v(_vm._s(_vm.$t('keyfeature-list5')))])]), _vm._v(" "), _c('li', [_vm._m(8), _vm._v(" "), _c('div', {
    staticClass: "features-detail title"
  }, [_vm._v(_vm._s(_vm.$t('keyfeature-list6')))])])]), _vm._v(" "), _c('div', {
    staticClass: "learn-more cur"
  }, [_c('router-link', {
    attrs: {
      "to": "/Feature"
    }
  }, [_vm._v(_vm._s(_vm.$t('learnmore')))])], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "home-part download"
  }, [_c('div', {
    staticClass: "home-info"
  }, [_c('p', {
    staticClass: "home-title title"
  }, [_vm._v(_vm._s(_vm.$t('download-title')))])]), _vm._v(" "), _c('div', {
    staticClass: "home-intro"
  }, [_c('img', {
    staticClass: "multi-device",
    attrs: {
      "src": require("../../assets/images/20180102/downloadpic@2x.png"),
      "alt": ""
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "home-intro-detail"
  }, [_vm._v(_vm._s(_vm.$t('download-detail')))])]), _vm._v(" "), _vm._m(9)])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "tool-pic"
  }, [_c('img', {
    attrs: {
      "src": require("../../assets/images/20180102/collaboration_pic@2x.png"),
      "alt": ""
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "tool-pic"
  }, [_c('img', {
    attrs: {
      "src": require("../../assets/images/20180102/communication_pic@2x.png"),
      "alt": ""
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "tool-pic"
  }, [_c('img', {
    attrs: {
      "src": require("../../assets/images/20180102/organization_pic@2x.png"),
      "alt": ""
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "feature-img"
  }, [_c('img', {
    attrs: {
      "src": require("../../assets/images/20180102/keyfeature_chat@2x.png"),
      "alt": ""
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "feature-img"
  }, [_c('img', {
    attrs: {
      "src": require("../../assets/images/20180102/keyfeature_voicecalls@2x.png"),
      "alt": ""
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "feature-img"
  }, [_c('img', {
    attrs: {
      "src": require("../../assets/images/20180102/keyfeature_sharing@2x.png"),
      "alt": ""
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "feature-img"
  }, [_c('img', {
    attrs: {
      "src": require("../../assets/images/20180102/keyfeature_synced@2x.png"),
      "alt": ""
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "feature-img"
  }, [_c('img', {
    attrs: {
      "src": require("../../assets/images/20180102/keyfeature_vioce@2x.png"),
      "alt": ""
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "feature-img"
  }, [_c('img', {
    attrs: {
      "src": require("../../assets/images/20180102/keyfeature_clouddrive@2x.png"),
      "alt": ""
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "home-download"
  }, [_c('a', {
    staticClass: "download-ios cur decoration",
    attrs: {
      "href": "https://itunes.apple.com/app/id1227620003"
    }
  }), _vm._v(" "), _c('a', {
    staticClass: "download-android cur decoration",
    attrs: {
      "href": "https://www.craitapp.com/download/crait.apk"
    }
  }), _vm._v(" "), _c('a', {
    staticClass: "download-google cur decoration",
    attrs: {
      "href": "https://play.google.com/store/apps/details?id=com.secrat.cloud"
    }
  }), _vm._v(" "), _c('a', {
    staticClass: "download-pc cur decoration",
    attrs: {
      "href": "https://fs.craitapp.com/download/crait-setup.exe"
    }
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-78b098af"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Home/Home.vue
// module id = 263
// module chunks = 1